import React from "react";

import SiteTitle from "./SiteTitle";
import MenuButton from "./MenuButton";

const NavigationBar = ({ siteTitle, openMenu, className, language, langs }) => (
  <header id="header" className={className}>
    <SiteTitle language={language}>{siteTitle}</SiteTitle>
    <MenuButton onClick={openMenu} language={language} langs={langs} />
  </header>
);

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/components/NavigationBar.js